import { generateTestId } from "@client-shared";

export const setPriceUpdatePopoverTestId = (identifier: string): string => generateTestId("PriceUpdatePopover", identifier);
